import { useState } from "react";
import { Link } from "react-router-dom";
import SEOHead from "@/components/feature/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const stats = [
  { label: "累计文章数", value: "5,800+", icon: "ri-article-line" },
  { label: "月活跃用户", value: "1,200万+", icon: "ri-user-star-line" },
  { label: "日浏览量", value: "350万+", icon: "ri-eye-line" },
  { label: "合作媒体", value: "120+", icon: "ri-building-line" },
];

const values = [
  {
    title: "真实客观",
    desc: "每一条爆料都经过多方核实，坚持用事实说话，拒绝标题党和虚假信息。",
    icon: "ri-shield-check-line",
  },
  {
    title: "极速响应",
    desc: "热点事件7×24小时全天候跟踪，确保你第一时间获取最新进展。",
    icon: "ri-flashlight-line",
  },
  {
    title: "保护隐私",
    desc: "严格保护爆料人身份信息，所有投稿采用匿名处理，安全无忧。",
    icon: "ri-lock-line",
  },
];

const milestoneData = [
  { year: "2019", event: "911吃瓜网正式上线，定位娱乐八卦与社会爆料垂直资讯平台" },
  { year: "2020", event: "日活跃用户突破100万，成为国内增长最快的吃瓜资讯平台" },
  { year: "2021", event: "上线独立App，实现PC+移动双端全覆盖，累计下载量突破500万" },
  { year: "2022", event: "组建专业调查记者团队，原创独家报道比例提升至30%" },
  { year: "2023", event: "月活跃用户突破1000万，入选年度最具影响力新媒体榜单" },
  { year: "2024", event: "推出AI智能推荐系统，用户阅读匹配度提升40%，人均阅读时长增长25%" },
  { year: "2025", event: "平台全面升级，新增深度扒皮、独家曝光等垂直栏目，内容生态更丰富" },
  { year: "2026", event: "月活突破1200万，与120+主流媒体建立内容合作关系，影响力持续扩大" },
];

const contactInfo = [
  { label: "爆料投稿", value: "tips@911chigua.com", icon: "ri-mail-line", href: "mailto:tips@911chigua.com" },
  { label: "商务合作", value: "biz@911chigua.com", icon: "ri-briefcase-line", href: "mailto:biz@911chigua.com" },
  { label: "微信客服", value: "911chigua", icon: "ri-wechat-line" },
  { label: "官方微博", value: "@911吃瓜网", icon: "ri-weibo-line" },
  { label: "Telegram", value: "@chigua911", icon: "ri-telegram-line" },
];

export default function About() {
  const [formStatus, setFormStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem("phone_alt") as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus("success");
      return;
    }

    setFormStatus("loading");
    setFormError("");

    try {
      const formData = new FormData(form);
      formData.delete("phone_alt");
      const response = await fetch("https://readdy.ai/api/form/d96binkut53jbls7km2g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed && (parsed as Record<string, unknown>).code === "OK") {
        setFormStatus("success");
        form.reset();
      } else {
        const serverMsg =
          (parsed as Record<string, unknown>)?.meta as Record<string, unknown> | undefined;
        setFormError(
          typeof serverMsg?.message === "string"
            ? serverMsg.message
            : typeof serverMsg?.detail === "string"
            ? serverMsg.detail
            : "提交失败，请稍后重试"
        );
        setFormStatus("error");
      }
    } catch {
      setFormError("网络异常，请检查网络后重试");
      setFormStatus("error");
    }
  };

  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于911吃瓜网",
    description: "911吃瓜网是国内领先的娱乐八卦与社会爆料垂直资讯平台，致力于为用户提供最新最热的吃瓜内容。",
    url: "https://911chigua.com/about",
    isPartOf: { "@type": "WebSite", name: "911吃瓜网", url: "https://911chigua.com" },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "911吃瓜网",
    url: "https://911chigua.com",
    description: "911吃瓜网 - 每日更新网红翻车、明星黑料、社会热点爆料的专业吃瓜平台",
    email: "tips@911chigua.com",
    sameAs: [
      "https://weibo.com/911chigua",
      "https://t.me/chigua911",
      "https://twitter.com/911chigua",
    ],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "business cooperation",
      email: "biz@911chigua.com",
      availableLanguage: "Chinese",
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://911chigua.com" },
      { "@type": "ListItem", position: 2, name: "关于我们", item: "https://911chigua.com/about" },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 911吃瓜网 | 品牌介绍与商务合作"
        description="911吃瓜网是国内领先的吃瓜资讯平台，每日更新网红翻车、明星黑料、社会热点爆料。了解我们的品牌故事、平台数据、发展历程和商务合作联系方式。"
        keywords="911吃瓜网,关于我们,吃瓜平台,商务合作,品牌介绍,平台数据"
        canonicalUrl="https://911chigua.com/about"
        schemaData={[aboutSchema, orgSchema, breadcrumbSchema]}
      />
      <Navbar />
      <main className="pt-16 min-h-screen bg-background-50">
        {/* Breadcrumb */}
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="px-4 md:px-6 py-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-500" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary-500 transition-colors">
                首页
              </Link>
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
              <span className="text-foreground-700">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Hero section */}
        <section className="relative w-full overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20interior%20with%20warm%20natural%20lighting%2C%20clean%20workspace%2C%20abstract%20decorative%20elements%2C%20soft%20beige%20and%20warm%20gray%20tones%2C%20editorial%20photography%2C%20peaceful%20atmosphere%2C%20professional%20corporate%20setting&width=1600&height=500&seq=about-hero-bg&orientation=landscape)`,
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>
          </div>
          <div className="relative z-10 px-4 md:px-6 py-14 md:py-20">
            <div className="max-w-3xl">
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
                关于<span className="text-primary-400">911吃瓜网</span>
              </h1>
              <p className="text-white/80 text-sm md:text-base leading-relaxed max-w-xl">
                国内领先的娱乐八卦与社会爆料垂直资讯平台。每日为你带来最新、最热、最劲爆的吃瓜内容，做你身边最靠谱的吃瓜伙伴。
              </p>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="px-4 md:px-6 -mt-10 relative z-20">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 text-center"
                >
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                    <i className={`${stat.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Brand story */}
        <section className="px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                我们的<span className="text-primary-500">品牌故事</span>
              </h2>
              <p className="text-foreground-500 text-sm max-w-2xl mx-auto">
                从一个简单的吃瓜分享站，到如今覆盖千万用户的垂直资讯平台
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14">
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4">品牌理念</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  在这个信息爆炸的时代，真实、有趣、有料的内容才是稀缺品。911吃瓜网诞生于一群热爱追踪娱乐八卦与社会热点的内容创作者之手——我们坚信，吃瓜不仅是一种消遣，更是一种参与公共讨论的方式。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们致力于打造一个集娱乐性、真实性和深度于一体的吃瓜平台。在这里，你不仅能第一时间吃到热乎的瓜，更能通过专业团队的深度调查，看到事件背后的真相。
                </p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4">内容准则</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  真实性是我们最核心的内容准则。所有发布在911吃瓜网的内容，都必须经过编辑团队的多方核实。我们建立了严格的事实核查流程，确保每一条爆料的源头可追溯。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  同时，我们坚持保护爆料人隐私、拒绝侵犯个人合法权益、抵制低俗内容。我们相信，好的吃瓜内容不需要靠博眼球来吸引流量——真相本身就足够精彩。
                </p>
              </div>
            </div>

            {/* Core values */}
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
              核心<span className="text-primary-500">价值观</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-14">
              {values.map((v) => (
                <div key={v.title} className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
                    <i className={`${v.icon} text-accent-500 text-xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-foreground-950 mb-2">{v.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>

            {/* Milestones */}
            <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-10">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
                发展<span className="text-primary-500">历程</span>
              </h2>
              <div className="space-y-0">
                {milestoneData.map((item, idx) => (
                  <div key={item.year} className="flex gap-4">
                    <div className="flex flex-col items-center">
                      <div className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center shrink-0">
                        <span className="text-white font-heading text-xs font-bold">{item.year}</span>
                      </div>
                      {idx < milestoneData.length - 1 && (
                        <div className="w-0.5 flex-1 bg-background-300 my-1 min-h-[20px]"></div>
                      )}
                    </div>
                    <div className="pb-8 pt-2">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.event}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Business cooperation */}
        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  商务<span className="text-primary-500">合作</span>
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-8">
                  911吃瓜网拥有千万级月活跃用户，覆盖18-35岁高消费力人群。我们提供品牌植入、内容定制、联合推广等多种合作方式。期待与您携手共创优质内容。
                </p>

                <div className="space-y-4">
                  {contactInfo.map((item) => (
                    <div key={item.label} className="flex items-center gap-4">
                      <div className="w-10 h-10 rounded-lg bg-background-50 border border-background-200/70 flex items-center justify-center shrink-0">
                        <i className={`${item.icon} text-primary-500`}></i>
                      </div>
                      <div>
                        <div className="text-xs text-foreground-500 mb-0.5">{item.label}</div>
                        {item.href ? (
                          <a
                            href={item.href}
                            className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors"
                          >
                            {item.value}
                          </a>
                        ) : (
                          <span className="text-sm font-medium text-foreground-700">{item.value}</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-6">
                  合作咨询
                </h3>
                <form
                  id="biz-contact-form"
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="space-y-4"
                >
                  <div>
                    <label htmlFor="biz-name" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      姓名 / 企业名称 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="biz-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的姓名或企业名称"
                    />
                  </div>
                  <div>
                    <label htmlFor="biz-email" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      电子邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="biz-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的电子邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="biz-type" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      合作类型 <span className="text-primary-500">*</span>
                    </label>
                    <select
                      id="biz-type"
                      name="cooperation_type"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                    >
                      <option value="">请选择合作类型</option>
                      <option value="brand">品牌植入</option>
                      <option value="content">内容定制</option>
                      <option value="joint">联合推广</option>
                      <option value="media">媒体合作</option>
                      <option value="other">其他</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="biz-message" className="block text-xs font-medium text-foreground-700 mb-1.5">
                      合作需求描述
                    </label>
                    <textarea
                      id="biz-message"
                      name="message"
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                      placeholder="请简要描述您的合作需求（不超过500字）"
                    ></textarea>
                    <div className="text-xs text-foreground-400 mt-1">最多500字符</div>
                  </div>

                  <div className="honeypot-field" aria-hidden="true">
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="honeypot-field"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={formStatus === "loading"}
                    className="w-full py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap"
                  >
                    {formStatus === "loading" ? (
                      <span className="flex items-center justify-center gap-2">
                        <i className="ri-loader-4-line animate-spin"></i>
                        提交中...
                      </span>
                    ) : (
                      "提交合作需求"
                    )}
                  </button>

                  {formStatus === "success" && (
                    <div className="p-3 rounded-lg bg-green-50 border border-green-200 text-green-700 text-xs text-center">
                      提交成功！我们将在1-3个工作日内与您联系。
                    </div>
                  )}
                  {formStatus === "error" && (
                    <div className="p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-xs text-center">
                      {formError || "提交失败，请稍后重试"}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}